import React, { Component } from 'react';
//import $ from 'jquery';
import api from '../../../services/api';
import { Modal } from 'react-bootstrap';
import querystring from 'querystring';
import loadingGif from '../../../img/loading-gif.gif';

export default class UsuarioForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			login: '',
			password: '',
			status: '',
			permissao: '',
		};

		if (this.props.item) {
			this.state = {
				id: this.props.item.id,
				login: this.props.item.login,
				password: '',
				status: this.props.item.status,
				permissao: this.props.item.permissao,
			};
		}

		this.setValidations();
		this.resetForm = this.resetForm.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeInput = this.handleChangeInput.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.item !== prevProps.item) {
			const item = this.props.item;

			this.setState({
				id: item.id,
				login: item.login,
				password: '',
				status: item.status,
				permissao: item.permissao,
			});
		}
	}

	cancelForm() {
		if (this.props.item) {
			const item = this.props.item;

			this.setState({
				id: item.id,
				login: item.login,
				password: '',
				status: item.status,
				permissao: item.permissao,
			});
		} else {
			this.resetForm();
		}
	}

	resetForm() {
		this.setState({
			login: '',
			password: '',
			status: '',
			permissao: '',
		});
	}

	handleChangeInput(e) {
		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value,
		});
	}

	async handleSubmit(e, setModalVisible) {
		e.preventDefault();
		if (!this.validate()) {
			return;
		}

		let self = this;
		//let form = this.state;

		const qsData = querystring.stringify(this.state);

		this.setState({ loading: true });
		const options = {
			//method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			//data: x,
			//url: '/admin/unidade',
		};

		try {
			const { data, status } = await api.post('/admin/usuario', qsData,options);
			//console.log(data, status);

			if (data.errors) {
				var keys = Object.keys(data.errors);
				var msgs = '';
				for (var i = 0; i < keys.length; i++) {
					msgs += data.errors[keys[i]] + '\n';
				}

				alert(msgs);
				this.setState({ loading: false });
			}

			if (status === 200 && data.id) {
				self.props.callback(data);
				//$('#' + self.props.elementId).modal('hide');
				setModalVisible(false);
				this.setState({ loading: false });
			} else {
				////console.log(status);
				////console.log(data);
				this.setState({ loading: false });
			}

			return;
		} catch (error) {
			this.setState({
				loading: false,
			});
			alert(error);
		}
	}

	validate() {
		var valid = true;
		var keys = Object.keys(this.validations);

		for (var i = 0; i < keys.length; i++) {
			if (this.validations[keys[i]].valid == null) {
				this.validations[keys[i]].valid = this.validations[keys[i]].validator(
					this.state[keys[i]]
				);
			}

			if (!this.validations[keys[i]].valid) {
				valid = false;
				continue;
			}
		}

		return valid;
	}

	setValidations() {
		this.validations = {
			login: {
				valid: null,
				message: 'login inválido',
				validator: function (value) {
					return true;
				},
			},
			password: {
				valid: null,
				message: 'senha inválida',
				validator: function (value) {
					return true;
				},
			},
			status: {
				valid: null,
				message: 'situação inválida',
				validator: function (value) {
					return true;
				},
			},
			permissao: {
				valid: null,
				message: 'permissão inválida',
				validator: function (value) {
					return true;
				},
			},
		};
	}

	render() {
		const props = this.props;
		const form = this.state;
		const { modalVisible, setModalVisible } = props;
		////console.log(props);

		return (
			<Modal
				show={modalVisible}
				onHide={() => {
					setModalVisible(false);
				}}>
				<Modal.Header>
					<h2 className='modal-title'>
						{props.item ? 'Editar Usuário' : 'Novo Usuário'}
					</h2>
				</Modal.Header>
				<Modal.Body>
					<form
						id={props.elementId + 'Elem'}
						onSubmit={(e) => {
							this.handleSubmit(e, setModalVisible);
						}}>
						<div className='modal-body'>
							<div className='form-group'>
								<label>Login</label>
								<input
									className='form-control'
									disabled={form.id ? 1 : 0}
									type='text'
									name='login'
									value={form.login}
									onChange={this.handleChangeInput}
								/>
							</div>
							<div className='form-group'>
								<label>Senha</label>
								<input
									className='form-control'
									type='password'
									name='password'
									value={form.password}
									onChange={this.handleChangeInput}
								/>
							</div>
							<div className='form-group'>
								<label>Situação</label>
								<select
									className='form-control'
									name='status'
									value={form.status}
									onChange={this.handleChangeInput}>
									<option>Selecione</option>
									<option value='1'>Ativo</option>
									<option value='0'>Desativado</option>
								</select>
							</div>
							<div className='form-group'>
								<label>Permissão</label>
								<select
									className='form-control'
									name='permissao'
									value={form.permissao}
									onChange={this.handleChangeInput}>
									<option>Selecione</option>
									<option value='1'>Consultor</option>
									<option value='2'>Administrador</option>
								</select>
							</div>
						</div>
						<div className='modal-footer'>
							<button
								type='button'
								onClick={(e) => {
									e.preventDefault();
									this.cancelForm();
									setModalVisible(false);
								}}
								className='btn btn-light border'
								data-dismiss='modal'>
								Cancelar
							</button>
							<button type='submit' className='btn btn-primary'>
								{form.loading ? (
									<img className='loadingImg' src={loadingGif} alt='loading' />
								) : (
									'Salvar'
								)}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		);
	}
}
